<div class="confirm">
  <div class="confirm__inner">
    <button class="mat-dialog__close-icon"><app-icon anchor="icon-close-xs" mat-dialog-close></app-icon></button>
    <header class="mb-3 mat-dialog__header">
      <h1 class="h3 mb-0" *ngIf="data.title">{{ data.title }}</h1>
      <!-- <p class="mb-0">Weet je het zeker dat je dit adres wilt verwijderen?</p> -->
    </header>

    <mat-dialog-content class="mb-0 pb-0">
      <div class="confirm__message mb-4" *ngIf="data.text">
        {{ data.text }}
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button class="button button-outline button--secondary me-auto mat-dialog-actions__button" (click)="confirm(false)">
        {{ data.actionLabels?.cancel || 'Anneleren' }}
      </button>
      <button class="button button--danger ms-auto mat-dialog-actions__button mt-3 mt-md-0" (click)="confirm(true)">
        {{ data.actionLabels?.proceed || 'OK' }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
